export default "__VITE_ASSET__USmFXZGv__"